import React from 'react';

const DocumentsIcon = ({
  width = '16',
  height = '16',
  fill = '#EF4821',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={fill}
    {...props}
  >
    <g clipPath="url(#clip0_620_27130)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.94198 1C4.59348 1 4.25925 1.1475 4.01282 1.41005C3.76639 1.6726 3.62795 2.0287 3.62795 2.4V3.8H6.22054C6.80329 3.79984 7.36955 4.00605 7.8303 4.38619C8.29105 4.76633 8.62014 5.29884 8.76583 5.9H12.7881H12.8262V2.4C12.8262 2.0287 12.6878 1.6726 12.4413 1.41005C12.1949 1.1475 11.8607 1 11.5122 1H4.94198ZM1.03667 6.6644C1.02813 6.47509 1.05576 6.28591 1.11788 6.10831C1.18 5.93072 1.27532 5.76841 1.39806 5.63122C1.5208 5.49404 1.66841 5.38484 1.83193 5.31023C1.99546 5.23562 2.1715 5.19717 2.34939 5.1972H6.22448C6.53396 5.19729 6.83348 5.31375 7.07026 5.52607C7.30704 5.73839 7.46589 6.03293 7.51881 6.3578L7.67255 7.2972H12.7907C12.9699 7.29724 13.1472 7.33632 13.3117 7.41204C13.4761 7.48776 13.6244 7.59852 13.7472 7.73751C13.87 7.8765 13.9649 8.04079 14.0259 8.22027C14.0869 8.39975 14.1129 8.59064 14.1021 8.7812L13.8262 13.684C13.8061 14.0403 13.659 14.375 13.415 14.6196C13.171 14.8642 12.8485 15.0003 12.5135 15H2.66345C2.32583 15.0001 2.00114 14.8617 1.75673 14.6135C1.51232 14.3654 1.36693 14.0265 1.35073 13.6672L1.03536 6.6644H1.03667Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_620_27130">
        <rect
          width="13.1404"
          height="14"
          fill="white"
          transform="translate(1 1)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default DocumentsIcon;
